import React, { useEffect } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { compose } from 'redux';
import DefaultLayoutHOC from '../layoutHOC/defaultLayout';
import Loader from '../../utils/Loader';
import License from './license';
import {
	fetchLicense,
	checkSpeech,
} from '../../redux/settings/settings.actions';
import ProfileTabLinks from '../common/profileTabLinks';
import ResetPIN from './resetPIN';
import ErrorToast from '../common/errorToast';
import { removeScript } from '../../utils/removeScript';
import EchoTest from '../common/EchoTest';
import Card from 'react-bootstrap/Card';
import ListAnimation from '../utils/animations/list';
const Settings = ({ fetchLicense, checkSpeech, isRetail }) => {
	useEffect(() => {
		Loader.hide();
		fetchLicense();
		checkSpeech();
		document.getElementById('profileHeader').classList.add('profilepageheader');

		return () => {
			removeScript('echoTest');
			document
				.getElementById('profileHeader')
				.classList.remove('profilepageheader');
		};
	}, [fetchLicense, checkSpeech]);

	return (
		<div className="settingsContainer">
			<ErrorToast />
			{window.outerWidth > 768 ? (
				<ProfileTabLinks />
			) : (
				<h4 className="section-body-title">Settings</h4>
			)}
			<ListAnimation open={true} className="profile_page_accordion ">
				<License />
				{/*<ResetPIN />*/}
				<div className="row">
					<div className="col-xs-12 col-md-12 col-sm-12 col-lg-12">
						<Card>
							<Card.Body>
								<a href="/logout" style={{ color: '#444' }}>
									<i className="fa fa-sign-out" aria-hidden="true"></i> Logout
								</a>
							</Card.Body>
						</Card>
					</div>
				</div>
				<EchoTest />
			</ListAnimation>
		</div>
	);
};

const mapDispatchToProps = (dispatch) => {
	return {
		fetchLicense: () => dispatch(fetchLicense()),
		checkSpeech: () => dispatch(checkSpeech()),
	};
};

const mapStateToProps = (state) => {
	return {
		isRetail: state.rootReducer.loginDetails.isRetail,
	};
};

export default withRouter(
	compose(
		connect(mapStateToProps, mapDispatchToProps),
		DefaultLayoutHOC,
	)(Settings),
);
